"use client";

import cn from "clsx";
import styles from "./DegreeOfferedCarousel.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Image from "next/image";

function DegreeOfferedCard({
  Image: ImageAttr,
  Subtitle,
}: {
  Image: any
  Subtitle: any
}) {
  const image = strapiSingleAttribute(ImageAttr?.source)
  return (
    <div
      className={cn(
        "relative flex flex-col border-primary-blue",
        styles.DegreeOffered__card
      )}
    >
      {ImageAttr?.enabled && (
        <div className={cn(styles.DegreeOffered__image)}>
          <Image
            src={image?.url}
            alt={image?.alternativeText || 'Degree Offered By Us'}
            className={cn(styles.DegreeOffered__img)+"object-cover rounded-xl"}
            title="Degree Offered By Us"
height={400}
width={800}
          />
        </div>
      )}
      {Subtitle?.enabled && (
        <p
          className={cn(
            "font-raleway",
            "text-secondary-gray",
            styles.DegreeOffered__subtitle
          )}
        >
          {Subtitle?.text}
        </p>
      )}
    </div>
  )
}

export default function DegreeOfferedCarousel({
  Image,
  Subtitle,
}: {
  Image: any;
  Subtitle: any;
}) {
  if (!Array.isArray(Image)) {
    return <DegreeOfferedCard Image={Image} Subtitle={Subtitle} />;
  }

  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      autoplay={{
        delay: 6000,
      }}
      spaceBetween={20}
      slidesPerView={1}
      pagination={{ clickable: true, bulletElement: "div" }}
      className={cn(
        "Carousel__blueBullet lg:Carousel__hAuto",
        styles.DegreeOffered__carousel,
      )}
    >
      {Image?.filter((x) => x.enabled)?.map((item: any, i: number) => {
        return (
          <SwiperSlide key={i}>
            <DegreeOfferedCard
              Image={{ enabled: true, source: item?.Image }}
              Subtitle={{ enabled: true, text: item?.Title }}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
